import Rest from '../rest'

/******************************************************************************
 * Simulator Rules
 *****************************************************************************/

/**
 * @type {Rest}
 */
export default class SimulatorRule extends Rest {
    /**
     * @param {String} resource
     */
    constructor () {
        super('/availability/simulatorRules')
    }
}